<div class="copy-link" *ngIf="link">
  <p>{{link}}</p>
  <div
    class="copy-link_icon"
    [life]="1000"
    tooltipEvent="focus"
    pTooltip="Copied!"
    tooltipPosition="top"
    (click)="copyClicked()">
    <img src="./assets/images/dealer-dashboard/copy-link.svg" alt="">
  </div>
</div>
